/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.navigation.title",
    defaultMessage: "B2B Portal"
  },
  itemPrehled: {
    id: "b2b.navigation.item.prehled",
    defaultMessage: "Overview"
  },
  itemProvozniInformace: {
    id: "b2b.navigation.item.provozni-informace",
    defaultMessage: "Operational Information"
  },
  itemRezervace: {
    id: "b2b.navigation.item.rezervace",
    defaultMessage: "Reservations"
  },
  itemRezervaceCasovyPlan: {
    id: "b2b.navigation.item.casovy-plan",
    defaultMessage: "Timetable"
  },
  itemRezervaceHistorie: {
    id: "b2b.navigation.item.historie",
    defaultMessage: "Request History"
  },
  itemRezervaceOdbaveni: {
    id: "b2b.navigation.item.rezervace.odbaveni",
    defaultMessage: "Request Handling"
  },
  itemRezervaceVytvoreni: {
    id: "b2b.navigation.item.rezervace.vytvoreni",
    defaultMessage: "New Reservation"
  },
  itemAdministrace: {
    id: "b2b.navigation.item.administrace",
    defaultMessage: "Administration"
  },
  itemAdministraceZakaznici: {
    id: "b2b.navigation.item.administrace.zakaznici",
    defaultMessage: "Customers"
  },
  itemAdministraceZdroje: {
    id: "b2b.navigation.item.administrace.zdroje",
    defaultMessage: "Resources"
  },
  itemAdministraceKonfiguracniParametry: {
    id: "b2b.navigation.item.administrace.konfiguracni-parametry",
    defaultMessage: "Parameters"
  }
});

export default () => useMessages(MESSAGES);
